export default __webpack_public_path__ + "static/media/edgar-timeline-pending-step.1be31d19.svg";